import { GraduationCap, Pencil } from "@/assets";
import { monthlySalaryMode, yearlySalaryMode } from "@/constants/common";
import { useProfile } from "@/context/useProfileProps";
import { getSalaryBasedOnSiteContext } from "@/helpers/getSalaryBasedOnSiteContext";
import { getMonthYear, getdateMonth } from "@/helpers/helper";
import { getSiteProps } from "@/utils";
import { BriefCase } from "@monsterindia/global-ui-components";

import { EducationData, EmploymentData, WidgetProps } from "../../types";

const EducationSection = ({
  educationData,
  setForm,
}: {
  educationData: EducationData;
  setForm: (value: number) => void;
}) => (
  <div className="bg-surface-background mb-3 mt-16 flex gap-3 rounded-lg border p-3">
    <GraduationCap width={32} height={32} />
    <div className="flex-1">
      <div className="text-content-primary text-[10px]">
        Highest Qualification
      </div>
      <div className="text-content-primary py-1 text-base font-medium">
        {educationData?.highestQualification?.text ?? ""}
      </div>
      <div className="text-content-secondary text-sm font-medium">
        {educationData?.specialization?.text ??
          educationData?.board?.text ??
          ""}
      </div>
      <div className="text-content-secondary pt-1 text-sm font-medium">
        {educationData?.yearOfPassing ? educationData?.yearOfPassing : ""}
        {educationData?.educationType?.text ? (
          <>
            <span className="px-1"> • </span>
            {educationData?.educationType?.text}
          </>
        ) : (
          ""
        )}
      </div>
    </div>
    <Pencil
      width={24}
      height={24}
      className="cursor-pointer"
      onClick={() => setForm(1)}
    />
  </div>
);

const EmploymentSection = ({
  employmentData,
  setForm,
}: {
  employmentData: EmploymentData;
  setForm: (value: number) => void;
}) => {
  const { hostname } = useProfile();
  const siteConfig = getSiteProps(hostname);
  const siteContext = siteConfig?.site_map ?? "rexmonster";

  const salaryData = getSalaryBasedOnSiteContext({
    currency: employmentData?.salary?.currency ?? "INR",
    absoluteSalary: employmentData?.salary?.absoluteValue ?? 0,
    siteContext,
    salaryMode: employmentData?.salary?.salaryMode
      ? employmentData?.salary?.salaryMode
      : siteContext === "rexmonster"
        ? {
            id: yearlySalaryMode,
          }
        : {
            id: monthlySalaryMode,
          },
  });

  const getNoticePeriodText = (days: number) => {
    if (!days) return "0";
    return days > 1 ? `${days} days` : "Immediately available";
  };

  return (
    <div className="bg-surface-background mb-3 mt-16 flex gap-3 rounded-lg border p-3">
      <BriefCase width={24} height={24} />
      <div className="flex-1">
        <div className="text-content-primary text-[10px]">Work Experience</div>
        <div className="text-content-primary text-base font-medium">
          {employmentData?.designation?.text ?? "-"}
        </div>
        <div className="text-content-secondary text-sm font-medium">
          {employmentData?.company?.text ?? "-"}
          {employmentData?.startDate && (
            <>
              <SectionSeparator />
              {getMonthYear(employmentData?.startDate)} -{" "}
              {employmentData?.endDate
                ? getMonthYear(employmentData?.endDate)
                : "Present"}
            </>
          )}
          {!!employmentData?.noticePeriod?.days && (
            <>
              <SectionSeparator />
              Notice Period:{" "}
              {employmentData?.noticePeriod?.serving
                ? `LWD ${getdateMonth(
                    employmentData?.noticePeriod?.lastWorkingDay ?? "",
                  )}`
                : getNoticePeriodText(employmentData?.noticePeriod?.days)}
            </>
          )}
          {employmentData?.salary?.absoluteValue ? (
            <>
              <SectionSeparator />
              Salary: {salaryData}
              {/* {employmentData?.salary?.currency ?? "INR"}{" "}
              {formatCurrency(
                employmentData?.salary?.absoluteValue,
                employmentData?.salary?.currency ?? "INR",
              )}
              {employmentData?.salary?.currency === "INR"
                ? " (Annually)"
                : " (Monthly)"} */}
            </>
          ) : (
            ""
          )}
        </div>
      </div>
      <Pencil
        width={24}
        height={24}
        className="cursor-pointer"
        onClick={() => setForm(2)}
      />
    </div>
  );
};

const SectionSeparator = () => {
  const { isMobile } = useProfile();
  if (isMobile) {
    return <br />;
  } else {
    return <span className="px-1"> • </span>;
  }
};

const Widget = ({ employmentData, educationData, setForm }: WidgetProps) => {
  return (
    <>
      {educationData && Object.keys(educationData).length > 0 && (
        <EducationSection educationData={educationData} setForm={setForm} />
      )}
      {employmentData && Object.keys(employmentData).length > 0 && (
        <EmploymentSection employmentData={employmentData} setForm={setForm} />
      )}
    </>
  );
};

export default Widget;
